import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import { Tooltip } from '@mui/material'

interface LabelForDueDateFieldProps {
  showAlert: boolean
  alertColor?: string
  tooltipMessage?: string
}

const LabelForDueDateField = ({
  showAlert,
  alertColor,
  tooltipMessage,
}: LabelForDueDateFieldProps) => (
  <>
    Validade
    {showAlert && (
      <Tooltip
        sx={{ cursor: 'pointer' }}
        title={tooltipMessage || ''}
        placement='top'
        arrow
        data-testid='alert-tooltip-test-id'
      >
        <ReportProblemIcon
          sx={{
            width: '19px',
            height: '19px',
            marginLeft: '.3rem',
            marginTop: '-.2rem',
          }}
          htmlColor={alertColor}
        />
      </Tooltip>
    )}
  </>
)

export default LabelForDueDateField
